export const BASE_URL = process.env.REACT_APP_BASE_URL
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL
export const REGISTRATION_FORM_URL = process.env.REACT_APP_REGISTER_FORM_URL
